<script>
export default {
  props: {
    dataDetail: Object
  },
  methods: {
    articleJumpTo(item) {
      console.log(item)
      if (item.toUrl !== "") {
        window.open(item.toUrl)
      } else {
        this.$router.push("/article_detail?article_id=" + item.id)
      }
    },
  }
}
</script>

<template>
  <div class="flex_column" style="width: 255px;height: 288px">

    <div style="position: relative;cursor: pointer;" v-on:click="articleJumpTo(dataDetail)">
      <el-image style="width: 255px;height: 174px;position: absolute;left: 0;top: 0"
                :src="dataDetail.imgUrl" fit="fill"/>
      <el-image style="width: 50px;height: 50px;position: absolute;top: 64px;left: 105px;"
                src="video_play-gray.png" fit="fill"/>
    </div>

    <div style="width: 255px;height: 174px;"></div>
    <div class="video_title font_auto_hidden" style="cursor: pointer;"  v-on:click="articleJumpTo(dataDetail)">{{ dataDetail.title }}</div>
    <div class="video_time">
      <div class="flex_row_vertical_center">
        <el-image style="width: 20px;height: 20px;"
                  src="peoples.png" fit="fill"/>
        <div style="margin-left: 4px">浏览量116</div>
      </div>

      <div>{{ $timeUtil.getYearMonthDate(dataDetail.time) }}</div>
    </div>
  </div>
</template>

<style scoped>
.video_title {
  margin: 12px 0 15px;
  height: 44px;
  font-size: 16px;
  line-height: 22px;
  overflow: hidden;
  text-align: left;
}

.video_time {
  padding-top: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-top: 1px solid #e5e5e5;
  font-size: 14px;
  line-height: 30px;
  color: #999;
}
</style>